"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const components_common_placeholder_loader_1 = require("@hotelplan/components.common.placeholder-loader");
const libs_context_device_type_1 = require("@hotelplan/libs.context.device-type");
const ContentLoader_utils_1 = require("./ContentLoader.utils");
const ContentLoader = props => {
    const { w, h, rects, circles, children, style } = props;
    const { mobile } = (0, libs_context_device_type_1.useDeviceType)();
    const deviceIndex = Number(!mobile);
    const width = w[deviceIndex] || w[0];
    const height = h[deviceIndex] || w[0];
    return (react_1.default.createElement(components_common_placeholder_loader_1.PlaceholderLoader, Object.assign({ width: width, height: height }, props, { style: Object.assign({ width: '100%', display: 'block' }, style) }),
        rects &&
            (0, ContentLoader_utils_1.renderRects)(typeof rects === 'function' ? rects(mobile) : rects),
        circles &&
            (0, ContentLoader_utils_1.renderCircles)(typeof circles === 'function' ? circles(mobile) : circles),
        children));
};
exports.default = ContentLoader;
//# sourceMappingURL=ContentLoader.js.map